import { FC } from "react";
import styles from "./OfferPreview.module.scss";
import { OFFER_GET_AGREEMENT } from "~/pages/questionnaires/v2/customer/api/apiUrls";

const baseURL = import.meta.env.VITE_APP_API_URL;

export const GetTextOfferAccept: FC = () => {
  return (
    <p className={styles.checkboxText}>
      Я даю Согласие о принятии рисков использования шаблона оферты{' '}
      <a
        href={baseURL + OFFER_GET_AGREEMENT}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.checkboxLink}
      >
        (посмотреть документ)
      </a>
    </p>
  );
};